/* Destilo — reveal elegante al hacer scroll para las secciones custom.
   Reutiliza el estado oculto definido en destilo-reveal.css (gated por
   html.da-ready) y añade .da-in cuando el elemento entra en viewport.
   No toca las secciones nativas de Dawn (que ya animan con scroll-trigger). */
(function () {
  window.__daInit = true;

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // En el editor o sin soporte/anim reducida: mostrar todo, sin ocultar nada.
  if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
    html.classList.remove('da-ready');
    return;
  }

  // Grupos: secciones que se revelan como bloque, y grids cuyas tarjetas
  // se escalonan (header primero, luego cada card con un pequeño retardo).
  var GROUPS = [
    { root: '.products-showcase', head: '.products-showcase__header', items: '.products-showcase__grid > *' },
    { root: '.experiences', head: '.experiences__header', items: '.experiences__cards > *' },
    { root: '.stories', head: '.stories__header', items: '.stories__grid > *' },
    { root: '.featured-info-bar' },
    { root: '.our-story' },
    { root: '.about-intro' },
    { root: '.cta-block-section' },
    { root: '.newsletter-split' },
    { root: '.drinks-studio' },
    { root: '.studio-intro' },
    { root: '.acc-section' },
    { root: '.favorites' },
    { root: '.family-form' },
    { root: '.collection-hero' }
  ];

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('da-in');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.04 }
  );

  function reveal(el, order) {
    if (!el) return;
    if (order) el.style.setProperty('--da-delay', Math.min(order, 8) * 80 + 'ms');
    io.observe(el);
  }

  function run(ctx) {
    ctx = ctx || document;
    GROUPS.forEach(function (g) {
      var roots = ctx.querySelectorAll ? ctx.querySelectorAll(g.root) : [];
      roots.forEach(function (sec) {
        if (g.items) {
          var head = g.head ? sec.querySelector(g.head) : null;
          var items = sec.querySelectorAll(g.items);
          if (head) reveal(head, 0);
          items.forEach(function (it, i) { reveal(it, i + (head ? 1 : 0)); });
          if (!head && !items.length) reveal(sec, 0);
        } else {
          reveal(sec, 0);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
})();
